import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {forkJoin} from "rxjs";
import {AppComponent} from '../app.component';
import {EmailRegex, PhoneFrRegex, maxSimuValidator} from '../const/utils';
import {User} from "../Models/User";
import {Function} from "../Models/Function";
import {Referential} from "../Models/Referential";
import {UserType} from "../Models/UserType";
import {UserTypes} from "../const/user-types";
import {UserTypeFormHelper} from "../helpers/user-type-form.helper";

@Component({
	selector: 'app-modal-admin-add-user',
	templateUrl: './modal-admin-add-user.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./modal-admin-add-user.component.less']
})
export class ModalAdminAddUserComponent implements OnInit {
	globalTxt: any;
	modalsTxt: any;
	modalInfo: any;
	submitted = false;
	userForm!: FormGroup;
	user!: User;
	userTypes: UserType[] = UserTypes;
	allFunctions: Function[] = [];
	allReferentials: Referential[] = [];
	userId: any = localStorage.getItem('user_id');
	userRole: any = localStorage.getItem('user_role');
	form_created: boolean = false;
	showMessageIfEmailExist: boolean = false;
	maxSimuTotal: number = 0;
	isEdition: boolean = false;

	constructor(
		public app: AppComponent,
		private userTypeFormHelper: UserTypeFormHelper,
		private formBuilder: FormBuilder,
	) {
		const token = JSON.parse(localStorage.getItem("token")!);
		this.maxSimuTotal = token?.simuTotal || 0;
	}

	get f() {
		return this.userForm.controls;
	}

	ngOnInit(): void {
		this.app.dataToolsService.currentModalInfo.subscribe(modalInfo => {
			console.log("modalInfo  => ", modalInfo);
			this.modalInfo = modalInfo;
		});

		forkJoin({
			fct: this.app.apiToolsService.getAllDataRef('FCT'),
			ref: this.app.apiToolsService.getAllDataRef('REF')
		}).subscribe({
			next: (results: any) => {
				this.allFunctions = results.fct?.Data;
				this.allReferentials = results.ref?.Data;
				// maintenant que les données sont chargées, initialiser le component
				this.getInfosInit();
			},
			error: (err) => {
				console.error('Erreur lors du chargement des référentiels', err);
			}
		});
	}

	getInfosInit() {
		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			this.userTypes = this.userTypes.map(userType => {
				return {
					...userType,
					Label: this.globalTxt.formFields[userType.Label] || userType.Label
				}
			});

			// Get the modal texts
			this.app.dataInitService.getModalTextsForModalComponentOnce(modalsTxt => {
				this.modalsTxt = modalsTxt.adminAddUser;

				this.modalsTxt.formFields.forEach((field: any) => {
					if (field.nameOptions) {
						field.options = this.getOptionsForItemParam(field) || [];
					}
				});

				let modalData = JSON.parse(localStorage.getItem('modalOpen')!);
				this.isEdition = !!(modalData?.data?.id && modalData.data.id !== -1);

				// Get the user data by ID
				if (modalData?.data?.id != -1) {
					// It's an edition: We get the user data by ID
					this.getUserDtoAltByIdAdmin(modalData.data.id);
				} else {
					// It's an addition: We create an empty form
					// Call the function to create the form
					this.doUserForm(null);
				}
			});
		});
	}

	getUserDtoAltByIdAdmin(_usrId: number) {
		this.app.apiToolsService.getUserDtoAltByIdAdmin(_usrId).subscribe(
			(user: any) => {
				console.log("res getUserDtoAltByIdAdmin ==> ", user);
				this.user = user;

				// Call the function to create the form
				this.doUserForm(this.user);

			}
		);
	}

	doUserForm(_user: any) {
		const controls: { [key: string]: any[] } = {
			USR_ID: [_user ? _user?.USR_ID : -1],
			USR_NUMERO_EXTERNE: [_user ? _user?.USR_NUMERO_EXTERNE : ''],
			FCT_ID: [_user ? _user?.FCT_ID : 3, [Validators.required]],
			REF_ID: [_user ? _user?.REF_ID : null, [Validators.required]],
			USR_PRENOM: [_user ? _user?.USR_PRENOM : '', [Validators.required]],
			USR_NOM: [_user ? _user?.USR_NOM : '', [Validators.required]],
			USR_EMAIL: [_user ? _user?.USR_EMAIL : '', [Validators.required, Validators.pattern(EmailRegex)]],
			USR_TEL_MOBILE: [_user ? _user?.USR_TEL_MOBILE : '', [Validators.required, Validators.pattern(PhoneFrRegex)]],
			USR_SIMU_TOTAL: [_user ? _user?.USR_SIMU_TOTAL : 0, [maxSimuValidator(this.maxSimuTotal)]],
			USR_SIMU_USED: [_user ? _user?.USR_SIMU_USED : 0],
			USR_ID_PARENT: [_user && _user.USR_ID_PARENT ? _user?.USR_ID_PARENT : parseInt(this.userId)],
			USR_TYPE: [_user && _user.USR_TYPE ? _user?.USR_TYPE : '', [Validators.required]],
			//USR_TYPE_REFERER: [_user && _user.USR_TYPE_REFERER ? _user?.USR_TYPE_REFERER : ''],
		};

		this.userForm = this.formBuilder.group(controls);
		console.log("this.userForm ==> ", this.userForm);

		// If USR_TYPE exists, we trigger the change to set the USR_TYPE_REFERER options
		if (this.userForm.get('USR_TYPE')?.value) {
			this.userTypeFormHelper.onTypeIdChange(this.userForm.get('USR_TYPE')?.value, 'USR_TYPE_REFERER', this.modalsTxt.formFields, this.userForm, true, this.app.sharedToolsService);
		}

		// si l'utilisateur possède déjà un USR_TYPE_REFERER, la mettre dans le formulaire
		if (_user && _user.USR_TYPE_REFERER) {
			this.userForm.get('USR_TYPE_REFERER')?.setValue(_user.USR_TYPE_REFERER);
		}

		// Set the form created to true
		this.form_created = true;

		// Setting up value change subscription for USR_TYPE
		this.userForm.get('USR_TYPE')?.valueChanges.subscribe(value => {
			console.log("value ==> ", value);
			this.userTypeFormHelper.onTypeIdChange(value, 'USR_TYPE_REFERER', this.modalsTxt.formFields, this.userForm, true, this.app.sharedToolsService);
		});
	}

	onSubmit() {
		console.log("this.userForm ==> ", this.userForm);
		console.log("this.userForm.value ==> ", this.userForm.value);

		this.showMessageIfEmailExist = false;

		this.submitted = true;

		if (this.userForm.invalid) {
			// ==> Show errorMessage
			console.log("Erreur dans le formulaire userForm");
			return;
		} else {
			console.log("Le formulaire est valide");
			// ==>  Call API to Save or Update the user
			if (this.userForm.value.USR_ID == -1) this.addUserDtoAltAdmin(this.userForm.value);
			else this.updateUserDtoAltAdmin(this.userForm.value);
		}
	}

	addUserDtoAltAdmin(userDto: User) {
		// If the function is "Client" (FCT_ID == 3), we don't send the mail
		//let sendMail = (userDto.FCT_ID == 3) ? 0 : 1;

		// For the admin add user, we always send the mail
		let sendMail: number = 1;
		this.app.apiToolsService.addUserDtoAltAdmin(userDto, sendMail).subscribe(
			(res: any) => {
				console.log("res addUserDtoAlt ==> ", res);
				this.app.confirmDialogService.confirmThis('', this.modalsTxt.modalSuccessAddUser, "alert", "",
					() => {
						location.reload();
					},
					() => {
					});
			},
			(error: any) => {
				console.error(error.error);
				if (error.status === 409) {
					this.showMessageIfEmailExist = true;
					return;
				}
			});
	}

	updateUserDtoAltAdmin(userDto: User) {
		this.app.apiToolsService.updateUserDtoAltAdmin(userDto).subscribe(
			(res: any) => {
				console.log("res updateUserDtoAlt ==> ", res);

				this.app.confirmDialogService.confirmThis('', this.modalsTxt.modalSuccessEditUser, "alert", "",
					() => {
						location.reload();
					}, () => {
					});
			},
			(error: any) => {
				console.error(error.error);
				if (error.status === 409) {
					this.showMessageIfEmailExist = true;
					return;
				}
			});
	}

	/*
	* Helpers for form select options
	* */
	getOptionsForItemParam(_item: { nameOptions?: 'allFunctions' | 'allReferentials' | 'userTypes' } | any): Function[] | Referential[] | UserType[] | undefined {
		type OptionKey = 'allFunctions' | 'allReferentials' | 'userTypes';

		const optionMap: Record<OptionKey, Function[] | Referential[] | UserType[] | undefined> = {
			allFunctions: this.allFunctions,
			allReferentials: this.allReferentials,
			userTypes: this.userTypes
		};

		const key = _item?.nameOptions as OptionKey | undefined;
		if (!key) return undefined;

		return optionMap[key];
	}
}
